













import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: 'IChecklist'
})

export default class IChecklist extends Vue {
  @Prop({type: String, default: () => '#0A0A0A'}) color!: string
  @Prop({type: String, default: () => '24'}) width!: string
  @Prop({type: String, default: () => '24'}) height!: string
}
